// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FormStyle{
    padding: 20px;
    background-color: #D2E0E3;
    border-radius: 0px 0px 20px 20px;
    /* font-size: 12px; */
}

.FormControl{
    /* height: auto !important; */
    background-color: transparent;
    border: solid 1px lightgray;
    border-radius: 4px;

    
}
.googleInput{
    width: 100%;
}
.ColloContainer{
    padding:8% !important;
}
.headerCardStyle{
    background-color: #D2E0E3;
    font-weight: bolder;
    border: none;
}

.CardStyle{
    display: flex;
    text-align: left;

}

.labelStyle{
    margin-bottom: 1px;
    margin-top: 8px;
    margin-left: 10px;
}


.containerForm{
    gap: 10px;
    padding: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    background-color: #FBFBFB;
    border-radius: 20px;
}
.containerForm .row{
    gap: 10px;
}
.containerForm .col{
    padding: 0%;
    color: grey;
        text-align: start;
}
.SelectAddress{
    font-size: 12px;
    background-color: transparent;
    border-color: grey;
    color: gray;
}
@media only screen and (max-width: 767px) {
    /* .CardStyleMittente{
        min-width: 220px;
        max-width: 320px;
    } */
}
@media only screen and (min-width: 768px) and (max-width: 1050px){
    /* .CardStyleMittente{
        min-width: 320px;
        max-width: 420px;
    } */
}
@media only screen and (min-width: 1050px) {
    /* .CardStyleMittente{
        min-width: 420px;
        max-width: 525px;
    } */
    .containerForm .row{
        gap: 40px;
        display: flex;
        justify-content: center;
    }
    .containerForm .col-12{
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        
    }
    .SelectCons{
        display: flex;
        flex-direction: column;
        justify-content: start;
        gap: 10px;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/CardMittente_Destinatatio/CardMittenteDest.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,6BAA6B;IAC7B,6BAA6B;IAC7B,2BAA2B;IAC3B,kBAAkB;;;AAGtB;AACA;IACI,WAAW;AACf;AACA;IACI,qBAAqB;AACzB;AACA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,gBAAgB;;AAEpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;AACrB;;;AAGA;IACI,SAAS;IACT,aAAa;IACb,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;AACvB;AACA;IACI,SAAS;AACb;AACA;IACI,WAAW;IACX,WAAW;QACP,iBAAiB;AACzB;AACA;IACI,eAAe;IACf,6BAA6B;IAC7B,kBAAkB;IAClB,WAAW;AACf;AACA;IACI;;;OAGG;AACP;AACA;IACI;;;OAGG;AACP;AACA;IACI;;;OAGG;IACH;QACI,SAAS;QACT,aAAa;QACb,uBAAuB;IAC3B;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;;IAEvB;IACA;QACI,aAAa;QACb,sBAAsB;QACtB,sBAAsB;QACtB,SAAS;IACb;AACJ","sourcesContent":[".FormStyle{\n    padding: 20px;\n    background-color: #D2E0E3;\n    border-radius: 0px 0px 20px 20px;\n    /* font-size: 12px; */\n}\n\n.FormControl{\n    /* height: auto !important; */\n    background-color: transparent;\n    border: solid 1px lightgray;\n    border-radius: 4px;\n\n    \n}\n.googleInput{\n    width: 100%;\n}\n.ColloContainer{\n    padding:8% !important;\n}\n.headerCardStyle{\n    background-color: #D2E0E3;\n    font-weight: bolder;\n    border: none;\n}\n\n.CardStyle{\n    display: flex;\n    text-align: left;\n\n}\n\n.labelStyle{\n    margin-bottom: 1px;\n    margin-top: 8px;\n    margin-left: 10px;\n}\n\n\n.containerForm{\n    gap: 10px;\n    padding: 10px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    background-color: #FBFBFB;\n    border-radius: 20px;\n}\n.containerForm .row{\n    gap: 10px;\n}\n.containerForm .col{\n    padding: 0%;\n    color: grey;\n        text-align: start;\n}\n.SelectAddress{\n    font-size: 12px;\n    background-color: transparent;\n    border-color: grey;\n    color: gray;\n}\n@media only screen and (max-width: 767px) {\n    /* .CardStyleMittente{\n        min-width: 220px;\n        max-width: 320px;\n    } */\n}\n@media only screen and (min-width: 768px) and (max-width: 1050px){\n    /* .CardStyleMittente{\n        min-width: 320px;\n        max-width: 420px;\n    } */\n}\n@media only screen and (min-width: 1050px) {\n    /* .CardStyleMittente{\n        min-width: 420px;\n        max-width: 525px;\n    } */\n    .containerForm .row{\n        gap: 40px;\n        display: flex;\n        justify-content: center;\n    }\n    .containerForm .col-12{\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        \n    }\n    .SelectCons{\n        display: flex;\n        flex-direction: column;\n        justify-content: start;\n        gap: 10px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
